import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
  class: "w-full flex flex-col absolute top-0 left-0 right-0 bottom-0"
};
const _hoisted_2 = {
  class: "grow w-full px-2 overflow-y-scroll"
};
import Pagination from "@/modules/vue/components/Pagination.vue";
import { TransitionFade } from "@morev/vue-transitions";
export default /*#__PURE__*/_defineComponent({
  __name: 'ItemsPaginator',
  props: {
    allItems: null,
    perPage: {
      default: 10
    },
    startPage: {
      default: 1
    }
  },
  emits: ['update'],
  async setup(__props, {
    expose,
    emit
  }) {
    let __temp, __restore;
    const props = __props;
    const {
      perPage,
      currentPage,
      pageCount,
      showPrevPage,
      showNextPage
    } = usePagination(props.perPage, props.startPage);
    const items = computed(() => collect(props.allItems).forPage(currentPage.value, perPage.value).toArray());
    const refreshing = ref(false);
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(() => useInitial(async () => {
      pageCount.value = Math.ceil(props.allItems.length / perPage.value);
      // for transition effect
      refreshing.value = true;
      nextTick(() => refreshing.value = false);
      emit('update', {
        items,
        currentPage,
        pageCount,
        perPage
      });
    })), __temp = await __temp, __restore(), __temp);
    watch(() => currentPage.value, () => refresh());
    expose({
      refresh
    });
    return (_ctx, _cache) => {
      const _component_NEmpty = _resolveComponent("NEmpty");
      const _directive_swipe_right = _resolveDirective("swipe-right");
      const _directive_swipe_left = _resolveDirective("swipe-left");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_unref(TransitionFade), {
        mode: "out-in",
        duration: 500
      }, {
        default: _withCtx(() => [!refreshing.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_unref(items).length === 0 ? _renderSlot(_ctx.$slots, "empty", {
          key: 0
        }, () => [_createVNode(_component_NEmpty, {
          description: _ctx.$t('no_entries')
        }, null, 8, ["description"])]) : _renderSlot(_ctx.$slots, "default", _normalizeProps(_mergeProps({
          key: 1
        }, {
          items: _unref(items),
          currentPage: _unref(currentPage),
          pageCount: _unref(pageCount),
          perPage: _unref(perPage),
          refresh: _unref(refresh)
        })))], 64)) : _createCommentVNode("", true)]),
        _: 3
      })])), [[_directive_swipe_right, _unref(showPrevPage)], [_directive_swipe_left, _unref(showNextPage)]]), _unref(items).length > 0 ? _renderSlot(_ctx.$slots, "pagination", _normalizeProps(_mergeProps({
        key: 0
      }, {
        items: _unref(items),
        currentPage: _unref(currentPage),
        pageCount: _unref(pageCount),
        perPage: _unref(perPage),
        refresh: _unref(refresh)
      })), () => [_createVNode(Pagination, {
        modelValue: _unref(currentPage),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(currentPage) ? currentPage.value = $event : null),
        "page-count": _unref(pageCount),
        onChange: _unref(refresh)
      }, _createSlots({
        _: 2
      }, [_ctx.$slots.display ? {
        name: "display",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "display", _normalizeProps(_guardReactiveProps({
          items: _unref(items),
          currentPage: _unref(currentPage),
          pageCount: _unref(pageCount),
          perPage: _unref(perPage),
          refresh: _unref(refresh)
        })))])
      } : undefined]), 1032, ["modelValue", "page-count", "onChange"])]) : _createCommentVNode("", true)]);
    };
  }
});